<template>
  <div class="mx-auto max-w-3xl space-y-12 pb-4">
    <header>
      <h1 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        {{ t('contact.title') }}
      </h1>
      <p class="mt-4 text-lg leading-relaxed text-gray-600">
        {{ t('contact.lead') }}
      </p>
    </header>

    <UAlert
      color="primary"
      variant="soft"
      icon="i-heroicons-information-circle"
      :title="t('contact.form_coming')"
    />

    <CompanyDetails />

    <section>
      <h2 class="text-xl font-bold text-gray-900">
        {{ t('contact.how_heading') }}
      </h2>
      <div class="mt-6 space-y-6">
        <div
          class="relative overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-b from-white to-primary-50/40 p-6 shadow-sm"
        >
          <span
            class="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-sm font-bold text-white"
          >1</span>
          <p class="pr-14 leading-relaxed text-gray-800">
            {{ t('contact.step1') }}
          </p>
        </div>
        <div
          class="relative overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-b from-white to-primary-50/40 p-6 shadow-sm"
        >
          <span
            class="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-sm font-bold text-white"
          >2</span>
          <p class="pr-14 leading-relaxed text-gray-800">
            {{ t('contact.step2') }}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

useHead(() => ({
  title: t('contact.meta_title'),
  meta: [{ name: 'description', content: t('contact.lead') }],
}))
</script>
